/**
 * The Server-Sent Events wire format → events. Fed text as it arrives (chunks end anywhere),
 * returns the events that are COMPLETE. One parser for the SSE builder and for an event
 * stream that answers an ordinary HTTP request (`utils/httpEventStreams.js`).
 */
export class SSEParser {
  constructor() {
    this._buf = '';
    this._heldCr = '';
    this._lastEventId = '';
  }

  feed(chunk) {
    // The spec allows CRLF and CR line ends. A CR at the very end of a chunk may be half of a
    // CRLF: hold it back, or one line end would count as two (= an event boundary).
    let text = this._heldCr + String(chunk);
    this._heldCr = '';
    if (text.endsWith('\r')) { this._heldCr = '\r'; text = text.slice(0, -1); }
    this._buf += text.replace(/\r\n?/g, '\n');
    const events = [];
    const blocks = this._buf.split(/\n\n/);
    this._buf = blocks.pop() ?? '';
    for (const block of blocks) {
      const lines = block.split(/\n/);
      let id = this._lastEventId;
      let event = 'message';
      const data = [];
      let retry = null;
      for (const line of lines) {
        if (line.startsWith(':')) continue;
        const colonIdx = line.indexOf(':');
        if (colonIdx === -1) {
          if (line === 'data') data.push('');
          continue;
        }
        const field = line.slice(0, colonIdx);
        const val = line.slice(colonIdx + 1).replace(/^ /, '');
        if (field === 'id') { id = val; this._lastEventId = val; }
        else if (field === 'event') { event = val; }
        else if (field === 'data') { data.push(val); }
        else if (field === 'retry') { const n = parseInt(val, 10); if (!isNaN(n)) retry = n; }
      }
      if (data.length === 0) continue;
      events.push({ id, event, data: data.join('\n'), retry, raw: block });
    }
    return events;
  }

  getLastEventId() { return this._lastEventId; }

  reset() { this._buf = ''; this._heldCr = ''; this._lastEventId = ''; }
}
